const AlertModal = (props) => {
    return (
        <div className="ModalBackground" onClick={props.onCancel}>
            <div className="AlertModal card" onClick={(e) => e.stopPropagation()}>

                <p className="large">{props.title || "Confirm Action"}</p>
                <p className="medium margin-top--large">{props.message}</p>

                <div className="flex col gap--normal margin-top--large">

                    <button className="Delete button large" onClick={props.onConfirm}>{props.confirmText || "Confirm"} </button>
                    <button className="button large  " onClick={props.onCancel}>{props.cancelText || "Cancel"}</button>
                </div>
            </div>
        </div>
    );
};

export default AlertModal;
